import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { Calendar, X } from "lucide-react";

export default function StickyCTA() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const { pathname } = useLocation();

  const HIDDEN_PATHS = ["/book", "/admin", "/admin/login", "/company-profile"];
  const isHidden = HIDDEN_PATHS.some((p) => pathname.startsWith(p));

  useEffect(() => {
    if (isHidden) return;
    const onScroll = () => {
      // Show after user scrolls past 60% of the hero (~600px)
      setShow(window.scrollY > 600);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [isHidden]);

  if (isHidden || dismissed) return null;

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, y: 24, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 24, scale: 0.95 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40"
          data-testid="sticky-cta"
        >
          <div className="relative flex items-center gap-3 pl-2 pr-1.5 py-1.5 rounded-full bg-[#0B2545] text-white shadow-2xl border border-white/10 backdrop-blur-xl">
            <div className="hidden sm:flex items-center gap-2 pl-3 pr-1">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#16A34A] opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-[#16A34A]" />
              </span>
              <span className="text-xs font-semibold tracking-wide">Free 30-min consultation</span>
            </div>
            <Link
              to="/book"
              data-testid="sticky-cta-book"
              className="inline-flex items-center gap-2 bg-[#16A34A] hover:bg-[#15803D] transition-colors text-white font-semibold text-sm px-4 py-2.5 rounded-full"
            >
              <Calendar size={14} />
              Book Now
            </Link>
            <button
              onClick={() => setDismissed(true)}
              data-testid="sticky-cta-close"
              aria-label="Dismiss"
              className="w-7 h-7 ml-0.5 rounded-full flex items-center justify-center text-white/60 hover:text-white hover:bg-white/10 transition"
            >
              <X size={13} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
